module.exports = __webpack_public_path__ + "img/logo-indosuez.ac3731ea.svg";